export { useCouponData } from "./useCouponData";
